import api from '../api';

import CrmSyncActions from 'actions/crm/CrmSyncActions';

/**
 * CrmSyncContactsByAccountIdSource implements interactions with contacts endpoints which return a list of contacts
 * associated with a given contact-account-id
 */
const CrmSyncContactsByAccountIdSource = {
  findContactsByAccountId: {
    remote(state, contactAccountId) {
      const config = {baseURL: '/apiv2/crm'};
      const data = {account: contactAccountId};
      return api.post(`/contacts`, data, config);
    },
    loading: CrmSyncActions.findContactsByAccountIdLoading,
    success: CrmSyncActions.findContactsByAccountIdSuccess,
    error: CrmSyncActions.findContactsByAccountIdError,
  },
};

export default CrmSyncContactsByAccountIdSource;
